import { getAccessToken } from "@auth0/nextjs-auth0";

export async function getAuth0TokenBrowser(): Promise<string | null> {
  try {
    return await getAccessToken();
  } catch (err) {
    console.error("Failed to get Auth0 access token", err);
    return null;
  }
}
